<img
  [style.width]="width" [style.height]="height"
  [style.min-width]="width" [style.min-height]="height"
  class="img-fluid user rounded" [class.has-level]="hasLevel"
  [src]="image ? image : defaultImg" alt="Avatar">
